// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__ci7_g","spinner":"Spinner_spinner__wKjmK","spinnerWrapper":"Spinner_spinnerWrapper__QyIer"};